<template>
  <div class="signin">
    <b-container fluid >
      <b-row align-h="center">
        <b-col cols="15" sm="5">
          <b-card header-tag="header" footer-tag="footer">
            <template v-slot:header>
              <h6 class="mb-0">Sign in</h6>
            </template>
            <b-form-group
              id="input-group-1"
              label="E-mail"
              class="label"
              label-for="email"
            >
              <b-form-input
                id="email-input"
                type="email"
                v-model="email"
                required
                placeholder="Enter your email..."
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-2"
              label="Password"
              class="label"
              label-for="password"
            >
              <b-form-input
                id="password-input"
                type="password"
                v-model="password"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-checkbox v-model="stay">Stay sign in?</b-form-checkbox>
            <b-button class="signin-btn" href="#" @click="reset" variant="danger">Cancel</b-button>
            <b-button class="signin-btn" href="#" @click="signIn" variant="primary">Sign in</b-button>
            <div>
              <b-link v-on:click="$bvModal.show('resetPassword')">Forgot your password?</b-link>
            </div>
            <template v-slot:footer>
              <b-link to="/signup">Create account?</b-link>
            </template>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <b-modal
      id="resetPassword"
      title="Reset your password"
      ok-title="Send reset email"
      @ok="sendReset"
      @cancel="clearResetEmail"
      @close="clearResetEmail"
      @hidden="clearResetEmail"
    >
      <h6>Please input your email address.</h6>
      <b-form-input
        id="reset-account-email"
        type="email"
        v-model="resetEmail"
        required
        placeholder="Enter your email..."
      ></b-form-input>
    </b-modal>
  </div>
</template>

<script>
import firebase from 'firebase'
export default {
  name: 'Signin',
  data () {
    return {
      email: '',
      password: '',
      stay: true,
      resetEmail: ''
    }
  },
  methods: {
    makeToast(variant = null, message) {
      this.$root.$bvToast.toast(message, {
        title: `${variant || 'message'}`,
        variant: variant,
        solid: true
      })
    },
    reset: function () {
      this.email = ''
      this.password = ''
      this.stay = true
    },
    signIn: function () {
      let sessionMode = ''
      if (this.stay === true) {
        sessionMode = firebase.auth.Auth.Persistence.LOCAL
      } else {
        sessionMode = firebase.auth.Auth.Persistence.SESSION
      }
      firebase.auth().setPersistence(sessionMode).then(() => {
        firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(res => {
          if (!res.user.emailVerified) {
            this.makeToast('warning', 'Not verified your email. Please verified.')
            firebase.auth().signOut().then(() => {
              this.$store.commit('setUser', null)
              this.reset()
              this.$router.push('/signin')
            })
          } else {
            this.$store.commit('setUser', res.user)
            this.makeToast('success', 'Logged in.')
            this.$router.push('/')
          }
        }, err => {
          this.makeToast('danger', err.message)
        })
      }).catch((error) => {
        this.makeToast('danger', error.message)
      })
    },
    sendReset: function () {
      let auth = firebase.auth()
      auth.sendPasswordResetEmail(this.resetEmail).then(() => {
        this.makeToast('success', 'Send password reset email.')
      }).catch(() => {
        this.makeToast('warning', 'Failed to send password reset email.')
      })
    },
    clearResetEmail: function () {
      this.resetEmail = ''
    }
  }
}
</script>

<style>
.signin {
  margin: 32px
}
.signin-btn {
  margin: 10px
}
.label {
  text-align: left
}
</style>

